/**
 * Marks English error copy for the `errors` catalog: `pnpm i18n:errors`
 * (`scripts/i18n/convex-error-messages.ts`) collects the message of every
 * `errorCopy('…')` call, so the web app can show it in the reader's language
 * by its text (`localizeErrorMessage`) wherever it travels: a constant a
 * Convex function throws, a refusal a helper returns, a toast's title.
 * At runtime it returns its argument; the message stays English for `/v1`,
 * MCP, Slack and logs.
 *
 * A string or template literal, or a conditional of them; a template's
 * conditional substitutions with literal branches make one entry each.
 *
 * LEAF MODULE, no imports: Convex functions import it.
 */
export function errorCopy<const T extends string>(message: T): T {
  return message
}
